import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { isValidators } from '../../utils/ValidatorUtils'
import { IconButton, Icon, Panel, Grid, Row, Col, ControlLabel, Input, SelectPicker } from 'rsuite'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'

export default function SearchProjectInformation({ schema: _schema, ...props }) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const { onSearch, onClean, hideDepartment, hideProjectType, hideProjectRound, projectTemplete } =
    props
  const [hidePro, setHidePro] = useState(true)
  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    // console.log('_schema', _schema)
    setSchema(_schema)

    setValue(_schema.projectType.name, _schema.projectType.value)
  }, [_schema])

  return (
    <>
      <Panel
        header={schema.header}
        eventKey={1}
        bordered
        collapsible
        defaultExpanded
        shaded
        expanded={hidePro}
        onSelect={() => setHidePro(!hidePro)}
      >
        <Grid fluid>
          <Row>
            {schema.projectCode && (
              <Col lg={8} md={8} sm={12} xs={24}>
                <p>{schema.projectCode.label}</p>
                <Input
                  name={schema.projectCode.name}
                  value={schema.projectCode.value}
                  inputRef={register(isValidators(schema.projectCode.validators))}
                  onChange={(value) => {
                    setSchema((_state) => {
                      let state = { ..._state }
                      state.projectCode.value = value
                      return state
                    })
                  }}
                ></Input>
              </Col>
            )}

            {schema.projectName && (
              <Col lg={8} md={8} sm={12} xs={24}>
                <p>{schema.projectName.label}</p>
                <Input
                  name={schema.projectName.name}
                  value={schema.projectName.value}
                  inputRef={register(isValidators(schema.projectName.validators))}
                  onChange={(value) => {
                    setSchema((_state) => {
                      let state = { ..._state }
                      state.projectName.value = value
                      return state
                    })
                  }}
                ></Input>
              </Col>
            )}

            {schema.projectType && !hideProjectType && (
              <Col lg={8} md={8} sm={12} xs={24} style={{ marginBottom: 10 }}>
                <p>{schema.projectType.label}</p>
                <Controller
                  name={schema.projectType.name}
                  control={control}
                  // defaultValue={schema.projectType.value}
                  value={schema.projectType.value}
                  rules={isValidators(schema.projectType.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={schema.projectType.options}
                        value={schema.projectType.value}
                        style={{ width: '100%' }}
                        searchable={false}
                        placeholder={`เลือก${schema.projectType.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          setSchema((_state) => {
                            let state = { ..._state }
                            state.projectType.value = value
                            return state
                          })
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema.projectTemplete && !projectTemplete && (
              <Col lg={8} md={8} sm={12} xs={24} style={{ marginBottom: 10 }}>
                <p>{schema.projectTemplete.label}</p>
                <Controller
                  name={schema.projectTemplete.name}
                  control={control}
                  // defaultValue={schema.projectTemplete.value}
                  value={schema.projectTemplete.value}
                  rules={isValidators(schema.projectTemplete.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={schema.projectTemplete.options}
                        value={schema.projectTemplete.value}
                        style={{ width: '100%' }}
                        searchable={false}
                        placeholder={`เลือก${schema.projectTemplete.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          setSchema((_state) => {
                            let state = { ..._state }
                            state.projectTemplete.value = value
                            return state
                          })
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}
            {schema.projectRound && !hideProjectRound && (
              <Col lg={8} md={8} sm={12} xs={24} style={{ marginBottom: 10 }}>
                <p>{schema.projectRound.label}</p>
                <Controller
                  name={schema.projectRound.name}
                  control={control}
                  // defaultValue={schema.projectRound.value}
                  value={schema.projectRound.value}
                  rules={isValidators(schema.projectRound.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={schema.projectRound.options}
                        value={schema.projectRound.value}
                        style={{ width: '100%' }}
                        searchable={true}
                        placeholder={`เลือก${schema.projectRound.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          setSchema((_state) => {
                            let state = { ..._state }
                            state.projectRound.value = value
                            return state
                          })
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema.projectBudget && (
              <Col lg={8} md={8} sm={12} xs={24}>
                <p>{schema.projectBudget.label}</p>
                <Controller
                  name={schema.projectBudget.name}
                  control={control}
                  // defaultValue={schema.projectBudget.value}
                  value={schema.projectBudget.value}
                  rules={register(isValidators(schema.projectBudget.validators))}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className={classNames(
                          'rs-input',
                          errors[schema.projectBudget.name] && 'is-error'
                        )}
                        thousandSeparator={true}
                        value={schema.projectBudget.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setSchema((_state) => {
                            let state = { ..._state }
                            state.projectBudget.value = value.floatValue
                            return state
                          })
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema.department && !hideDepartment && (
              <Col lg={8} md={8} sm={12} xs={24} style={{ marginBottom: 10 }}>
                <p>{schema.department.label}</p>
                <Controller
                  name={schema.department.name}
                  control={control}
                  // defaultValue={schema.projectType.value}
                  value={schema.department.value}
                  rules={isValidators(schema.department.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        size="lg"
                        data={schema.department.options}
                        value={schema.department.value}
                        style={{ width: '100%' }}
                        searchable={false}
                        placeholder={`เลือก${schema.department.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          setSchema((_state) => {
                            let state = { ..._state }
                            state.department.value = value
                            return state
                          })
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 10, textAlign: 'left' }}>
              <IconButton
                appearance="ghost"
                size="md"
                icon={<Icon appearance="ghost" icon="search" className="bt-gost-icon-radius" />}
                style={{ marginBottom: '10px', marginRight: '10px', width: 120 }}
                onClick={handleSubmit(onSearch)}
              >
                ค้นหา
              </IconButton>

              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-edit"
                size="md"
                icon={
                  <Icon
                    appearance="ghost"
                    icon="close-circle"
                    className="bt-gost-icon-radius-edit"
                  />
                }
                style={{ marginBottom: '10px', width: 120 }}
                onClick={onClean}
              >
                ล้างข้อมูล
              </IconButton>
            </Col>
          </Row>
        </Grid>
      </Panel>
    </>
  )
}
